import React, { Component } from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { Badge } from "react-bootstrap";
import CustomFieldHelper from "../../_Helpers/CustomFieldHelper"
import * as inspectionDefectCrud from '../../../../crud/inspectionDefect.crud';
import { notificationAggregateListTagsFilter, notificationUniqueTagsFilter } from "../../../../store/helpers/FilterHelper";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import BaseListPage from '../../_CustomComponents/BaseListPage';

export const getBatchFormFields = (fields, replyFields) => {
    const formFields = [
        {
            caption: fields.Subject.label,
            dataField: 'replyactiondetail',
            required: fields.Subject.required,
            dataType: 'string'
        },
    ];

    if (fields.Compensation.visible) {
        formFields.push({
            caption: fields.Compensation.label,
            dataField: 'inspectiontime',
            required: fields.Compensation.required,
            dataType: 'integer'
        })
    }
    if (fields.DecisionRequiredBy.visible) {
        formFields.push({
            caption: fields.DecisionRequiredBy.label,
            dataField: 'inspectiondatedisplay',
            required: fields.DecisionRequiredBy.required,
            dataType: 'date',
        })
    }
    if (fields.Details.visible) {
        formFields.push({
            caption: fields.Details.label,
            dataField: 'inspectiondetails',
            required: fields.Details.required,
            dataType: 'long-string',
        })
    }

    if (replyFields) {
        if (replyFields.ReplyStatus.visible) {
            formFields.push({
                caption: replyFields.ReplyStatus.label,
                dataField: 'replystatus',
                required: replyFields.ReplyStatus.required,
                dataType: 'list',
                options: {
                    dataSource: replyFields.ReplyStatus.replyOptions,
                    valueExpr: 'value',
                    displayExpr: 'display'
                },
                isReplyField: true
            })
        }

        if (replyFields.ReplyComment.visible) {
            formFields.push({
                caption: replyFields.ReplyComment.label,
                dataField: 'replycomment',
                required: replyFields.ReplyComment.required,
                dataType: 'long-string',
                isReplyField: true
            })
        }
    }

    return formFields;
}

class AssumptionList extends BaseListPage {
    constructor(props) {
        super(props);

        this.notificationsTagsEnabled = process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true' && props.contract.specifictags?.length > 0;
        this.notificationsRelsEnabled = process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true';
        this.customFields = [];
        if (props.customFields) {
            if (props.customFields.COMMUNICATION && props.customFields.COMMUNICATION.length > 0) {
                this.customFields.push(...(props.customFields.COMMUNICATION.filter(cf => cf.includelisting)));
            }
            if (props.customFields.REPLY && props.customFields.REPLY.length > 0) {
                this.customFields.push(...(props.customFields.REPLY.filter(cf => cf.includelisting)));
            }
        }

        this.batchFormFields = getBatchFormFields(props.workflowItem.fields, props.workflowItem.replyFields, this.props.intl);

        this.state = {
            notifications: null,
            tags: null
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.fetchNotifications();
    }

    fetchNotifications = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data: responseObj } = await inspectionDefectCrud.getContractInspections(companyid, projectid, contractid, this.props.notificationType, this.props.accessibleWfIds);
            let listData = notificationAggregateListTagsFilter(JSON.parse(responseObj.aggregatelist));
            listData = (this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed === true) ?
                listData :
                listData.filter(ntf => ntf.showtasknotification === 1);

            let tagFilters = notificationUniqueTagsFilter(JSON.parse(responseObj.uniquetags));

            this.setState({ notifications: listData, tags: tagFilters });
        } catch (error) {
            console.log(error);
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }

    }

    onTableSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            const url = this.calculateUrl(data, true);
            this.props.navigate(url);
        }
    }

    calculateUrl = (rowData, skipHostUrl) => {
        return (skipHostUrl ? '' : process.env.PUBLIC_URL) + this.props.workflowItem.paths.basePath + rowData.inspectiondefectid;
    }

    renderStatusColumn = (cellInfo) => {
        let badgeVariant = 'secondary';
        switch (cellInfo.data.replystatus) {
            case 'Awaiting Reply':
            case 'Awaiting Acceptance':
                badgeVariant = 'warning';
                break;
            case 'Not Communicated':
                badgeVariant = 'secondary';
                break;
            case 'Uncorrected':
            case 'Not Accepted':
                badgeVariant = 'danger';
                break;
            case 'Communicated':
            case 'Reply Received':
            case 'Accepted':
                badgeVariant = 'success';
                break;
            default:
                break;
        }
        const displayText = this.calculateStatusValue(cellInfo.data);
        return (<Badge variant={badgeVariant}>{displayText}</Badge>);
    }
    calculateStatusValue = (rowData) => {
        return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.' + rowData.replystatus });
    }
    render() {
        if (!this.state.notifications) {
            return (<PortletSpinner />);
        }

        const columns = [
            { resource: "GENERAL.FORMS.FIELD.ID", dataField: "referenceid", dataType: 'string', renderReferenceidLink: true },
            { resource: "GENERAL.FORMS.FIELD.SUBJECT", dataField: 'replyactiondetail' },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_DATE", dataField: "notificationdate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_BY", dataField: "communicatedby" },
            { resource: "GENERAL.FORMS.FIELD.REPLY_REQUIRED", dataField: "inspectiondate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.STATUS", dataField: "replystatus", cellRender: this.renderStatusColumn, calculateCellValue: this.calculateStatusValue },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
            { resource: "PROJECT.FIELD.CODE", dataField: "projectcode", visible: false },
            { resource: "PROJECT.FIELD.NAME", dataField: "project", visible: false },
            { resource: "GENERAL.FORMS.FIELD.REPLY_RECIEVED", dataField: "replydate", dataType: 'date', visible: false },
            { resource: "GENERAL.FORMS.REPLING_PARTY", dataField: "replyingparty", lookup: { dataSource: this.props.contractTemplate.parties.options, valueExpr: 'id', displayExpr: 'display' }, visible: false },
            { resource: "GENERAL.FORMS.FIELD.CREATED_BY", dataField: "createby", visible: false },
            { resource: "GENERAL.FORMS.FIELD.REPLY_CREATED_BY", dataField: "replycreatebyname", visible: false },
            { resource: "GENERAL.FORMS.FIELD.DRAFT_NOTIFIED_TO", dataField: "lastdraftednotifiedtoname", visible: false },
            { resource: "GENERAL.FORMS.FIELD.REPLY_DRAFT_NOTIFIED_TO", dataField: "lastreplydraftednotifiedtoname", visible: false },

        ];
        if (this.props.workflowItem.assetFieldsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.ASSET_NAME", dataField: "assetname", visible: false },
                { resource: "GENERAL.FORMS.FIELD.ASSET_TYPE", dataField: "assettype", visible: false },
            );
        }
        if (this.notificationsTagsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.PORTFOLIO", dataField: "tags_portfolio", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.PortfolioFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROGRAMME", dataField: "tags_programme", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProgrammeFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROJECT", dataField: "tags_project", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProjectFilter } },
                { resource: "GENERAL.FORMS.FIELD.OTHER", dataField: "tags_other", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.OtherFilter } }
            )
        }
        if (this.notificationsRelsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.TAB_RELATIONS", dataField: "relatednotices", visible: false },
            )
        }
        columns.push(...CustomFieldHelper.MapCustomFieldsToDataGridColumns(this.customFields));

        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="1"
                        //BATCH OPS
                        batchOperations={true}
                        batchFormFields={this.batchFormFields}
                        batchImportEndpoint={inspectionDefectCrud.importInspectionDefects}
                        batchDeleteEndpoint={inspectionDefectCrud.deleteInspectionDefectDrafts}
                        batchCommunicateEndpoint={inspectionDefectCrud.communicateInspectionDefectDrafts}
                        onBatchRecordsUpdated={this.fetchNotifications}
                        customFields={this.props.customFields}
                        //BATCH OPS
                        title={this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.TITLE2' }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                        createPath={this.props.workflowItem.userFilters.mainNotice.createAllowed ? this.props.workflowItem.paths.createPath : null}
                        workflowItem={this.props.workflowItem}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.notifications}
                        keyExpr="inspectiondefectid"
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        columns={columns}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}




export default withListPageProps(AssumptionList);
